import { CategorizationAnnotation } from "../../configMap/interfaces/category";

export const equals = (
  obj1: CategorizationAnnotation,
  obj2:
    | CategorizationAnnotation
    | {
        documentId: string;
        categorizationId: string;
        index: number;
        groupBlockId?: string;
      },
) => {
  return (
    obj1.documentId === obj2.documentId &&
    obj1.categorizationId === obj2.categorizationId &&
    obj1.groupBlockId === obj2.groupBlockId &&
    obj1.index === obj2.index
  );
};
